import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';
import { consumeTelegramRedirect } from './auth/telegramBootstrap';

// Telegram Login Widget Redirect-flow оставляет токен в location.hash.
// Считываем ДО первого render'а, чтобы App увидел уже сохранённый токен
// в localStorage и сразу попал в авторизованное состояние.
consumeTelegramRedirect();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
